import { render } from "./BuyingContent.vue?vue&type=template&id=250346ce&scoped=true"
import script from "./BuyingContent.vue?vue&type=script&lang=js"
export * from "./BuyingContent.vue?vue&type=script&lang=js"

import "./BuyingContent.vue?vue&type=style&index=0&id=250346ce&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250346ce"]])

export default __exports__